import React from "react";
import HeroPage from "../HeroPage/HeroPage";

const Passengers = () => {
  return (
    <div>
     <h4>Currently Under Development</h4>
    </div>
  );
};

export default Passengers;
